@if (dealModel.appliedDeals().length) {
    <div class="deals" [class.divided]="divided()">
        @if (!hideTitle() && dealModel.dealLimit() !== 1) {
            <div class="deals-title">{{ "woa.heading.deals.activeDeals" | translate }}</div>
        }
        @for (deal of dealModel.appliedDeals(); track deal) {
            <woa-content-message class="deals-deal"
                                 [level]="MessageLevel.SUCCESS" [layout]="MessageLayout.HORIZONTAL"
                                 [icon]="'tags'" [text]="'woa.message.deals.isApplied'"
                                 [link]="'woa.button.common.remove'" (onLinkActivate)="removeDeal(deal)"
                                 [translationParams]="{'dealName': dealModel.getDealName(deal)}"></woa-content-message>
        }
        @if (dealsMessage()) {
            <div class="deals-message"
                 [innerHTML]="dealsMessage() | translate:{limit: dealModel.dealLimit()} | html"></div>
        }
    </div>
}
